import { getFaviconPath } from './lib/env-utils.ts'

const faviconPath = getFaviconPath()
if (faviconPath !== 'favicon-32x32.png') {
  const link = document.getElementById('favicon')
  if (link instanceof HTMLLinkElement) {
    link.href = faviconPath
  }
}
